<template>
  <!-- Lo que antes llegaba en la campana como un párrafo de veinticuatro municipios (#1210). Aquí
       es donde se trabaja, así que es donde vive el desglose entero: agrupado por motivo y con los
       mismos municipios y personas que el aviso. Si no hay nada pendiente no se pinta nada, y si
       no se ha podido calcular se dice: callar dejaría creer que el calendario está cerrado. -->
  <div v-if="avisos.length || fallo" class="festivos-avisos">
    <f7-block v-if="fallo" strong class="aviso-fallo no-margin-bottom">
      {{ $t('festivos.avisos.noCargado') }}
      <f7-link class="margin-left-half" @click="cargar()">{{ $t('festivos.reintentar') }}</f7-link>
    </f7-block>
    <f7-block v-for="aviso in avisos" :key="aviso.tipo + aviso.anio" strong class="aviso no-margin-bottom">
      <div class="aviso-cabecera" @click="alternar(aviso)">
        <i class="f7-icons aviso-icono">exclamationmark_triangle_fill</i>
        <span class="aviso-titulo">{{ tituloDe(aviso) }}</span>
        <f7-link class="aviso-alternar">
          {{ abierto(aviso) ? $t('festivos.avisos.ocultar') : $t('festivos.avisos.verDetalle') }}
        </f7-link>
      </div>
      <div v-if="abierto(aviso)" class="aviso-detalle">
        <div v-for="grupo in aviso.grupos || []" :key="grupo.motivo" class="aviso-grupo">
          <div class="aviso-grupo-titulo">
            {{ nombreMotivo(grupo.motivo) }}
            <span v-if="grupo.motivo !== 'SIN_MUNICIPIO'" class="aviso-grupo-cuenta">({{ (grupo.lineas || []).length }})</span>
          </div>
          <div class="aviso-grupo-descripcion">{{ grupo.descripcion }}</div>
          <ul v-if="grupo.motivo !== 'SIN_MUNICIPIO'" class="aviso-lineas">
            <li v-for="(linea, i) in grupo.lineas" :key="i">{{ linea }}</li>
          </ul>
          <template v-else>
            <div class="aviso-sin-municipio">
              {{ $tc('festivos.avisos.personasSinMunicipio', aviso.personasSinMunicipio, { n: aviso.personasSinMunicipio }) }}
              <f7-link class="margin-left-half" @click="alternarPersonas()">
                {{ personasAbiertas ? $t('festivos.avisos.ocultar') : $t('festivos.avisos.verQuienes') }}
              </f7-link>
            </div>
            <div v-if="personasAbiertas" class="aviso-personas">
              <div v-if="personasCargando">{{ $t('festivos.avisos.cargandoPersonas') }}</div>
              <div v-else-if="personasFallo">
                {{ $t('festivos.avisos.personasNoCargadas') }}
                <f7-link class="margin-left-half" @click="cargarPersonas()">{{ $t('festivos.reintentar') }}</f7-link>
              </div>
              <ul v-else class="aviso-lineas">
                <li v-for="p in personas" :key="p.username">
                  <!-- La ficha es donde se pone el domicilio. El enlace se dibuja solo si esa
                       ficha se puede abrir (regla de pantalla §9); si no, el nombre va en texto. -->
                  <f7-link v-if="p.empleadoId && puedeAbrirFicha" :href="'/empleados/view/' + p.empleadoId + '/'">
                    {{ p.nombre }}
                  </f7-link>
                  <span v-else>{{ p.nombre }}</span>
                  <span class="aviso-usuario"> · {{ p.username }}</span>
                </li>
              </ul>
            </div>
          </template>
        </div>
      </div>
    </f7-block>
  </div>
</template>

<script>
import Festivo from "./../../js/db/Festivo.js";
import PermisosEmpleados from "./../empleados/permisos.js";
import { EventBus } from "./../../js/EventBus";

/**
 * Bloque de avisos de Ajustes · Festivos (#1210). Pide el cálculo fresco —aquí es donde se arregla
 * lo que falta— y lo reparte por `festivos:avisos` para que el indicador de la cabecera diga lo
 * mismo que este bloque sin esperar a su siguiente consulta.
 */
export default {
  name: 'festivosAvisos',
  props: {
    // Se abre de entrada cuando se llega desde el indicador: se viene a ver el detalle.
    abrirDeEntrada: { type: Boolean, default: false }
  },
  data: function() {
    return {
      avisos: [],
      fallo: false,
      abiertos: {},
      personas: [],
      personasAbiertas: false,
      personasCargando: false,
      personasFallo: false,
      ultimaPeticion: 0,
      ultimaPeticionPersonas: 0
    };
  },
  computed: {
    puedeAbrirFicha: function() {
      return PermisosEmpleados.abrirFicha();
    }
  },
  methods: {
    clave: function(aviso) {
      return aviso.tipo + ':' + aviso.anio;
    },
    abierto: function(aviso) {
      return !!this.abiertos[this.clave(aviso)];
    },
    alternar: function(aviso) {
      this.$set(this.abiertos, this.clave(aviso), !this.abierto(aviso));
    },
    tituloDe: function(aviso) {
      const n = aviso.problemas || 0;
      return this.$tc(aviso.tipo === 'OCTUBRE' ? 'festivos.avisos.tituloOctubre' : 'festivos.avisos.tituloEnero',
        n, { n: n, anio: aviso.anio });
    },
    nombreMotivo: function(motivo) {
      const clave = 'festivos.avisos.motivos.' + motivo;
      if (this.$te(clave)) return this.$t(clave);
      const estado = 'festivos.estados.' + motivo;
      return this.$te(estado) ? this.$t(estado) : motivo;
    },
    cargar: function() {
      const self = this;
      // Solo cuenta la última respuesta: validar dos municipios seguidos lanza dos cargas, y la
      // primera en volver no puede pisar lo que ya dice la segunda.
      const peticion = ++self.ultimaPeticion;
      return Festivo.avisos(true).then(function(res) {
        if (peticion !== self.ultimaPeticion) return;
        self.avisos = Array.isArray(res) ? res : [];
        self.fallo = false;
        if (self.abrirDeEntrada) {
          self.avisos.forEach(function(a) {
            if (self.abiertos[self.clave(a)] === undefined) self.$set(self.abiertos, self.clave(a), true);
          });
        }
        if (self.personasAbiertas) self.cargarPersonas();
        EventBus.$emit('festivos:avisos', self.avisos);
      }).catch(function() {
        if (peticion !== self.ultimaPeticion) return;
        self.avisos = [];
        self.fallo = true;
      });
    },
    alternarPersonas: function() {
      this.personasAbiertas = !this.personasAbiertas;
      if (this.personasAbiertas) this.cargarPersonas();
    },
    cargarPersonas: function() {
      const self = this;
      // Igual que `cargar`: cada recálculo de los avisos vuelve a pedir la lista, y una respuesta
      // vieja no puede devolver a la lista a quien ya tiene domicilio.
      const peticion = ++self.ultimaPeticionPersonas;
      self.personasCargando = true;
      self.personasFallo = false;
      Festivo.personasSinMunicipio().then(function(res) {
        if (peticion !== self.ultimaPeticionPersonas) return;
        self.personas = Array.isArray(res) ? res : [];
        self.personasCargando = false;
      }).catch(function() {
        if (peticion !== self.ultimaPeticionPersonas) return;
        self.personas = [];
        self.personasCargando = false;
        self.personasFallo = true;
      });
    }
  }
};
</script>

<style scoped>
.festivos-avisos .aviso {
  border-left: 4px solid #ef6c00;
}
.aviso-cabecera {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.aviso-icono {
  color: #ef6c00;
  font-size: 18px;
  margin-right: 8px;
}
.aviso-titulo {
  font-weight: 600;
  flex: 1;
}
.aviso-detalle {
  margin-top: 8px;
}
.aviso-grupo {
  margin-top: 10px;
}
.aviso-grupo-titulo {
  font-weight: 600;
}
.aviso-grupo-cuenta,
.aviso-usuario {
  color: #777;
  font-weight: normal;
}
.aviso-grupo-descripcion {
  color: #555;
  font-size: 13px;
}
.aviso-lineas {
  margin: 4px 0 0 0;
  padding-left: 20px;
}
.aviso-fallo {
  color: #8a5300;
}
</style>
